module.exports = __webpack_public_path__ + "static/media/DuskPhotographywithCompanion.f3d8e220.svg";